const { getNode, getCurrentMedia, listenToMedia } = globals;
const container = getNode('.component-practical-detail');
const sidebar = getNode('.sidebar', container);
const practicalDetailSidebar = getNode('.component-practical-detail-sidebar', container);
const pdContainer = getNode('.pd-container', container);
const sideBarHeaderNode = getNode('.pds-list-header-mobile.pds-list-item', practicalDetailSidebar);
const sideBarSelectedNode = getNode('.pds-list-item.selected', practicalDetailSidebar);

function handlePracticalDetailMobileSidebar() {
    practicalDetailSidebar.classList.toggle('open-mobile-menu');
}

function onMediaChange(media) {
    switch (media) {
        case 'mobile': 
            sideBarHeaderNode.innerText = sideBarSelectedNode.innerText;
            sidebar.parentNode.prepend(sidebar);
            if (practicalDetailSidebar) {
                practicalDetailSidebar.addEventListener('click', handlePracticalDetailMobileSidebar);
            }
            break;
        default:
            sidebar.parentNode.insertBefore(sidebar, pdContainer);
            practicalDetailSidebar.removeEventListener('click', handlePracticalDetailMobileSidebar);
            break;
    }
}

export function initPracticalDetailContentPage()
{
    //Check if current page is component-practical-detail page.
    if (!container) {
        return;
    }
    onMediaChange(getCurrentMedia());
    listenToMedia(onMediaChange);
}


// Auto-initialize if this script is loaded
initPracticalDetailContentPage();